const NotFound = (name) => (
  () => (
    <div style={{ display: 'block' }}>
      {process.env.production ? '' : `Motion: View "${name}" not found`}
    </div>
  )
)

export default NotFound



/** WEBPACK FOOTER **
 ** ./client/views/NotFound.js
 **/